import { render } from "./UserSelect.vue?vue&type=template&id=a3a7f90e"
import script from "./UserSelect.vue?vue&type=script&lang=js"
export * from "./UserSelect.vue?vue&type=script&lang=js"

import "./UserSelect.vue?vue&type=style&index=0&id=a3a7f90e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__